import { Orientation, type SerializedDockview } from 'dockview';
import type { TypedGroupviewPanelState } from '../../../../types/LayoutConfig';
import { BRANCH, LEAF, MAIN_GROUP_ID } from '../../../Layout/tokens';
import { BLOTTER_PANELS_WITHOUT_ALLOCATIONS } from './shared';

const MANUAL_RFQS_BLOTTERS_GROUP = {
  type: LEAF,
  data: {
    views: [
      'orders',
      'trades',
      'otcDerivatives',
      'loans',
      'rfqs',
      'reconMismatches',
      'transfers',
      'hedgePositionStatus',
    ],
    activeView: 'rfqs',
    id: 'blotters',
  },
  size: 1400,
};

const PANELS: Record<string, TypedGroupviewPanelState> = {
  manualRfqs: {
    id: 'manualRfqs',
    contentComponent: 'manualRfqs',
    params: {
      type: 'manualRfqs',
      showAllDecimals: false,
    },
    title: 'Manual RFQs',
  },
  ...BLOTTER_PANELS_WITHOUT_ALLOCATIONS,
};

const GRID: SerializedDockview['grid'] = {
  root: {
    type: BRANCH,
    data: [
      {
        type: LEAF,
        data: {
          views: ['manualRfqs'],
          activeView: 'manualRfqs',
          id: MAIN_GROUP_ID,
        },
        size: 800,
      },
      {
        type: BRANCH,
        data: [
          MANUAL_RFQS_BLOTTERS_GROUP,
          {
            type: LEAF,
            data: {
              views: ['positions', 'balances', 'credit'],
              activeView: 'positions',
              id: '1',
            },
            size: 900,
          },
        ],
        size: 500,
      },
    ],
    size: 2300,
  },
  width: 2300,
  height: 1300,
  orientation: Orientation.VERTICAL,
};

export const MANUAL_RFQS_LAYOUT: SerializedDockview = {
  grid: GRID,
  panels: PANELS,
};
